import { type EditorState, Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet, type EditorView } from 'prosemirror-view';

import { schema } from '../schema';

type PlaceholderMeta =
  | { add: { id: object; pos: number } }
  | { remove: { id: object } };

export const imageUploadPlugin = new Plugin<DecorationSet>({
  state: {
    init() { return DecorationSet.empty; },
    apply(tr, set) {
      let next = set.map(tr.mapping, tr.doc);
      const meta = tr.getMeta(imageUploadPlugin) as PlaceholderMeta | undefined;
      if (meta && 'add' in meta) {
        const widget = document.createElement('span');
        widget.className = 'pm-image-placeholder';
        const deco = Decoration.widget(meta.add.pos, widget, { id: meta.add.id });
        next = next.add(tr.doc, [deco]);
      } else if (meta && 'remove' in meta) {
        next = next.remove(next.find(undefined, undefined, (spec) => spec.id === meta.remove.id));
      }
      return next;
    },
  },
  props: {
    decorations(state) { return this.getState(state); },
  },
});

export function findPlaceholder(state: EditorState, id: object): number | null {
  const decos = imageUploadPlugin.getState(state);
  const found = decos?.find(undefined, undefined, (spec) => spec.id === id);
  return found && found.length ? found[0].from : null;
}

export function startImageUpload(
  view: EditorView,
  file: File,
  upload: (file: File) => Promise<string>,
): void {
  const id = {};
  const tr = view.state.tr;
  if (!tr.selection.empty) tr.deleteSelection();
  tr.setMeta(imageUploadPlugin, { add: { id, pos: tr.selection.from } });
  view.dispatch(tr);

  upload(file).then(
    (url) => {
      const pos = findPlaceholder(view.state, id);
      if (pos == null) return;
      view.dispatch(
        view.state.tr
          .replaceWith(pos, pos, schema.nodes.image.create({ src: url }))
          .setMeta(imageUploadPlugin, { remove: { id } }),
      );
    },
    () => {
      view.dispatch(view.state.tr.setMeta(imageUploadPlugin, { remove: { id } }));
    },
  );
}
